import * as React from 'react';
import Page from '../components/Page';
import { getStoreState } from '../state/Store';

export default class extends React.Component {
  goHome = () => {
    getStoreState().app.history.replace('/');
  };
  render() {
    return (
      <Page>
        <div style={{ textAlign: 'center' }}>
          <h1>404 Page Not Found</h1>
          <p>
            Nothing interesting to see here.<br />
            Probably nothing has ever been here and will never be.
          </p>
          <button
            className="large primary"
            style={{ marginTop: 20 }}
            onClick={this.goHome}
          >
            Go to editor
          </button>
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/404/index.tsx